export default __webpack_public_path__ + "static/media/img5.935dfb15.png";